import React from 'react';
import { ReactFlowProvider } from '@xyflow/react';
import DevicesTab from './DevicesTab';

interface FlowDevicesProps {
  siteId: string;
  companyId: string;
}

const FlowDevices: React.FC<FlowDevicesProps> = ({ siteId, companyId }) => {
  return (
    <div className="h-[calc(100vh-235px)] w-full overflow-hidden">
      <ReactFlowProvider>
        <DevicesTab siteId={siteId} companyId={companyId} />
      </ReactFlowProvider>
    </div>
  );
};

export default FlowDevices;